export class ExportTimesheet {
    constructor(
        public submittedOn: string,
        public memberName: string,
        public projectName: string,
        public timesheetDate: string,
        public requiredHours: string,
       // public timesheetFrequency: string,
        public submittedHours: string,
        public billedHours: string,
        public status: string,
        public leaves: string
    ) {}
}
